"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Svg_1 = __importDefault(require("../Svg"));

var CreditCardMastercard = function CreditCardMastercard(_a) {
  var fill = _a.fill,
      props = __rest(_a, ["fill"]);

  return react_1.default.createElement(Svg_1.default, __assign({}, props, {
    viewBox: "0 0 28 16"
  }), react_1.default.createElement("g", {
    transform: "translate(-1227.75 -271.857)"
  }, react_1.default.createElement("g", {
    transform: "translate(1227.75 271.857)"
  }, react_1.default.createElement("path", {
    fill: "#ff0016",
    d: "M91.75,6.577a8,8,0,1,0,0,10.559,7.969,7.969,0,0,1,0-10.559Z",
    transform: "translate(-77.75 -3.857)"
  }), react_1.default.createElement("path", {
    fill: "#ff0016",
    d: "M89.393,6.043a7.969,7.969,0,0,0,0,10.559,7.969,7.969,0,0,0,0-10.559Z",
    transform: "translate(-75.393 -3.323)"
  })), react_1.default.createElement("path", {
    fill: "#ffa916",
    d: "M95.386,3.857a7.981,7.981,0,0,0-6,2.72,8.1,8.1,0,0,0-.915,1.279H90.3a8.05,8.05,0,0,1,.7,1.6H87.762a7.864,7.864,0,0,0-.335,1.6h3.9a7.689,7.689,0,0,1,.055.8c0,.27-.016.536-.042.8H87.426a7.919,7.919,0,0,0,.335,1.6h3.246a8.06,8.06,0,0,1-.709,1.6H88.469a8.087,8.087,0,0,0,.916,1.279,8,8,0,1,0,6-13.28Z",
    transform: "translate(1152.366 268)"
  })));
};

CreditCardMastercard.displayName = 'CreditCardMastercard';
exports.default = CreditCardMastercard;